<template>
    <section id="mainContainer">
        <userHeader></userHeader>
        <section class="mid-container">
            <section class="page-banner-section"
                :style="{ 'background-image': `url(${require('@/assets/images/about-banner-img.jpg')})` }">
                <div class="container">
                    <h1>About LMD Consulting</h1>
                </div>
            </section>
            <section class="join-contact-form-section">
                <div class="container">
                    <div class="form-tabs--top">
                        <ul class="nav" id="myTab" role="tablist">
                            <li>
                                <a class="active" id="tab-a" data-bs-toggle="tab" href="#taba" role="tab"
                                    aria-controls="taba" aria-selected="true">Contact Us</a>
                            </li>
                            <li>
                                <a id="tab-b" data-bs-toggle="tab" href="#tabb" role="tab" aria-controls="tabb"
                                    aria-selected="false">Join Our Team</a>
                            </li>
                        </ul>
                    </div>
                    <div class="form-tabs--btm tab-content" id="myTabContent">
                        <div class="tab-pane fade show active" id="taba" role="tabpanel" aria-labelledby="tab-a">
                            <div class="contact-form">
                                <form @submit.prevent="submitContactUs">
                                <div class="row">
                                    <div class="col-sm-4">
                                        <div class="input-field">
                                            <input type="text" placeholder=" Name" v-model="contactUsForm.name"/>
                                            <div class="error-msg" v-if="contactUsErrors.name">{{ contactUsErrors.name }}</div>
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="input-field">
                                            <input type="email" placeholder=" Email" v-model="contactUsForm.email"/>
                                            <div class="error-msg" v-if="contactUsErrors.email">{{ contactUsErrors.email }}</div>
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="input-field">
                                            <input type="text" placeholder=" Subject" v-model="contactUsForm.subject"/>
                                            <div class="error-msg" v-if="contactUsErrors.subject">{{ contactUsErrors.subject }}</div>
                                        </div>
                                    </div>
                                    <div class="col-sm-12">
                                        <div class="input-field">
                                            <textarea placeholder=" Message" v-model="contactUsForm.message"></textarea>
                                            <div class="error-msg" v-if="contactUsErrors.message">{{ contactUsErrors.message }}</div>
                                        </div>
                                    </div>
                                    <div class="col-sm-12">
                                        <div class="input-submit">
                                            <button class="primary-btn-outline" :disabled="isSubmitting">
            {{ isSubmitting ? 'Submitting...' : 'Submit' }}
        </button>
                                            <button type="button" class="primary-btn-outline" @click="resetContactUsForm">Reset</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                            </div>
                        </div>
                        <div class="tab-pane fade" id="tabb" role="tabpanel" aria-labelledby="tab-b">
    <form @submit.prevent="submitApplication">
        <div class="joinus-form">
            <div class="row">
                <div class="col-sm-4">
                    <div class="input-field">
                        <input type="text" placeholder=" Name" v-model="applicationForm.candidateName" />
                        <div class="error-msg" v-if="applicationErrors.candidateName">{{ applicationErrors.candidateName }}</div>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div class="input-field">
                        <input type="email" placeholder="Email Address*" v-model="applicationForm.email" />
                        <div class="error-msg" v-if="applicationErrors.email">{{ applicationErrors.email }}</div>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div class="input-field">
                        <select class="selectbox" v-model="applicationForm.designation">
                            <option value="">Select Job</option>
                            <option v-for="category in jobCategories" :key="category.id" :value="category.title">
                                {{ category.title }}
                            </option>
                        </select>
                        <div class="error-msg" v-if="applicationErrors.designation">{{ applicationErrors.designation }}</div>
                    </div>
                </div>
                <!-- Other fields remain unchanged as they don't need specific error messages -->
                <div class="col-sm-4">
                    <div class="input-field">
                        <input type="text" placeholder="Name of your Reference (if any)"
                            v-model="applicationForm.nameOfReference" />
                    </div>
                </div>
                <div class="col-sm-4">
                    <div class="input-field">
                        <div class="browse-input">
                            <div class="browse-field">
                                <div class="browse-button company-logo">Upload Image</div>
                                <input type="file" @change="handleFileUpload($event)" accept="image/jpeg,image/jpg,image/png" :key="fileInputKey" />
                                
                            </div>
                            <div class="browsed-img" v-if="imageUploaded"><img :src="imageUrl" alt="" /></div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div class="input-field">
                        <div class="browse-input">
                            <div class="browse-field">
                                <div class="browse-button company-logo">Upload Resume</div>
                                <input type="file" @change="handleResumeUpload($event)" accept=".pdf, .docx" :key="fileInputKey" />
                                <div class="error-msg" v-if="!selectedResumeFile && applicationErrors.candidateResume">{{ applicationErrors.candidateResume }}</div>
                                            <div class="custom-progress-bar" v-if="uploadProgress > 0">
                                                <div class="custom-progress-bar-left"> <span :style="`width:${uploadProgress}%`"></span></div>
                                                <div class="custom-progress-bar-right">{{uploadProgress}}%</div>
                                            </div>
                            </div>
                            <div class="browsed-img" v-if="resumeUploaded">{{ ResumeName }}</div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-12">
                    <div class="input-field">
                        <textarea placeholder="Details" v-model="applicationForm.description"></textarea>
                        <div class="error-msg" v-if="!applicationForm.description">{{ errMsg }}</div>
                    </div>
                </div>
                <div class="col-sm-12">
                    <div
                    id="aboutUsCaptchaWidget"
                    class="g-recaptcha"
                    ></div>
                    <div class="error-msg" v-if="recaptchaError">
                    {{ recaptchaError }}
                    </div>
                </div>
                <div class="col-sm-12">
                    <div class="input-submit">
                        <button class="primary-btn-outline" :disabled="isSubmitting">
            {{ isSubmitting ? 'Submitting...' : 'Submit' }}
        </button>
                        <button type="button" class="primary-btn-outline" @click="resetForm">Reset</button>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>
                    </div>
                </div>
            </section>

            <section class="our-location-section">
                <div class="container">
                    <h2>Our Locations</h2>
                    <div class="location-map">
                        <img src="@/assets/images/map.png" alt="world-map" class="world-map" />
                        <div class="address-bg usa">
                            <div class="address">
                                <ul>
                                    <li><i class="fa fa-home"></i> <span>21515 Ridgetop Circle Suite 150 Sterling, VA
                                            20166</span></li>
                                    <li><i class="fa fa-phone"></i> <span>+1 571-313-8814</span></li>
                                    <li><i class="fa fa-envelope"></i> <span><a
                                                href="mailto:hello@lmdconsulting.com">hello@lmdconsulting.com</a></span>
                                    </li>
                                </ul>
                                <img src="@/assets/images/location-icon.png" class="map-icon">
                            </div>
                        </div>

                        <div class="address-bg india">
                            <div class="address">
                                <ul>
                                    <li><i class="fa fa-home"></i> <span>2nd Floor, Plot No. B-2/19, Gandhipath,
                                            Chitrakoot, Jaipur, Rajasthan 302021</span></li>
                                    <li><i class="fa fa-phone"></i> <span>+91 141-491-5291</span></li>
                                    <li><i class="fa fa-envelope"></i> <span><a
                                                href="mailto:hello@lmdconsulting.com">hello@lmdconsulting.com</a></span>
                                    </li>
                                </ul>
                                <img src="@/assets/images/location-icon.png" class="map-icon">
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </section>
        <userFooter></userFooter>
        <ChatbotPopup ref="chatbotPopup"></ChatbotPopup>
    </section>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import userHeader from "@/components/userHeader.vue";
import userFooter from "@/components/userFooter.vue";
import axios from 'axios';
import Swal from 'sweetalert2';
import { API_BASE_URL } from '@/config/api.config';
import { loadRecaptchaScript } from '@/utils/captcha';
import ChatbotPopup from '@/components/chatbotPopup.vue';

declare global {
  interface Window {
    grecaptcha: {
      ready: (callback: () => void) => void;
      render: (
        container: string | HTMLElement,
        parameters: {
          sitekey: string;
          callback?: (token: string) => void;
          "expired-callback"?: () => void;
          theme?: "light" | "dark";
          size?: "normal" | "compact";
        }
      ) => number;
      reset: (widgetId?: number) => void;
      getResponse: (widgetId?: number) => string;
    };
    onRecaptchaLoad?: () => void;
    recaptchaCallbacks?: Array<() => void>;
  }
}

interface ApplicationForm {
    candidateName: string;
    email: string;
    designation: string;
    nameOfReference: string;
    candidateImage: string | null;
    candidateResume: File | null;
    description: string;
}

interface ContactUsForm {
    name: string;
    email: string;
    subject: string;
    message: string;
}

export default defineComponent({
    name: "About-Us",
    components: {
        userHeader,
        userFooter,
        ChatbotPopup
    },
    data() {
        return {

            applicationForm: {
                candidateName: '',
                email: '',
                designation: '',
                nameOfReference: '',
                candidateImage: null,
                candidateResume: null,
                description: ''
            } as ApplicationForm,
            jobCategories: [] as any,
            imageSrc: '',
            selectedImageFile: null as File | null,
            imageUploaded: false,
            selectedResumeFile: null as File | null,
            errMsg: '',
            ResumeName: '',
            resumeUploaded: false,
            fileInputKey: 0,
            contactUsForm:{
                name: '',
                email: '',
                subject: '',
                message: ''
            } as ContactUsForm,
            contactUsErrors: {
                    name: '',
                    email: '',
                    subject: '',
                    message: ''
                }, // Replace errContactUsMsg with this

            // Add this for Join Our Team form errors
          applicationErrors: {
            candidateName: '',
            email: '',
            designation: '',
            candidateResume: ''
        },
        isSubmitting: false, // Add this to track submission state
        recaptchaSiteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY!,
        recaptchaToken: "",
        recaptchaWidgetId: null as number | null,
        recaptchaError: "",
        uploadProgress: 0,
        isExtracting: false,
        missingDataQuestions: [] as Array<{missing_item: string, question: string}>,
        missingDataAnswers: {} as {[key: number]: string},
        extractedResumeSections: null as any,
        activeAccordion: -1,
        suppressLocalSave: false as boolean,
    };
    },
    computed: {
        imageUrl(): string {
            return this.imageSrc || require('@/assets/images/admin-img/image-icon.svg');
        },
    },
    mounted() {
        loadRecaptchaScript(this.onRecaptchaLoad.bind(this));
        this.getJobCategories();
        this.loadFromLocalStorage();
    },
    watch: {
        'applicationForm.candidateName'() { this.saveToLocalStorage(); },
        'applicationForm.email'() { this.saveToLocalStorage(); },
        'applicationForm.designation'() { this.saveToLocalStorage(); },
        'applicationForm.nameOfReference'() { this.saveToLocalStorage(); },
        'applicationForm.description'() { this.saveToLocalStorage(); },
        'missingDataAnswers': {
            handler() { this.saveToLocalStorage(); },
            deep: true
        },
        'resumeUploaded'() { this.saveToLocalStorage(); },
        'imageUploaded'() { this.saveToLocalStorage(); },
    },
    beforeUnmount() {
        this.cleanupRecaptcha();
    },
    methods: {
        async submitApplication() {
    // Prevent submission if already submitting
    if (this.isSubmitting) return;

    // Set submitting state
    this.isSubmitting = true;

    // Clear previous errors
    this.applicationErrors = {
        candidateName: '',
        email: '',
        designation: '',
        candidateResume:''
    };
    this.errMsg = '';

    let hasErrors = false;

    // Validate specific fields
    if (!this.applicationForm.candidateName) {
        this.applicationErrors.candidateName = 'Please enter a name';
        hasErrors = true;
    }
    if (!this.applicationForm.email) {
        this.applicationErrors.email = 'Please enter an email';
        hasErrors = true;
    } else if (!this.isValidEmail(this.applicationForm.email)) {
        this.applicationErrors.email = 'Please enter a valid email address';
        hasErrors = true;
    }
    if (!this.applicationForm.designation) {
        this.applicationErrors.designation = 'Please select a job';
        hasErrors = true;
    }
    if (!this.selectedResumeFile) {
        this.applicationErrors.candidateResume = 'Please upload your resume.';
        hasErrors = true;
    } else if (!this.resumeUploaded || this.uploadProgress < 100) {
        Swal.fire({
            icon: 'warning',
            title: 'Resume Upload',
            text: 'Please wait for resume upload to complete.',
            showConfirmButton: false,
            timer: 1800
        });
        hasErrors = true;
    }
    if (!this.recaptchaToken) {
        this.recaptchaError = 'Please verify you are not a robot.';
        hasErrors = true;
    }

    // // Validate other fields with generic error message
    // if (!this.applicationForm.description || !this.selectedImageFile || !this.selectedResumeFile) {
    //     this.errMsg = 'All fields are required';
    //     hasErrors = true;
    // }

    // If there are errors, stop here and reset submitting state
    if (hasErrors) {
        this.isSubmitting = false;
        if (
            !this.recaptchaToken &&
            window.grecaptcha &&
            this.recaptchaWidgetId !== null
        ) {
            window.grecaptcha.reset(this.recaptchaWidgetId);
        }
        return;
    }

    await axios.post(`${API_BASE_URL}/chat-message/`, {
        session_id: sessionStorage.getItem("chat_session_id"),
        message: "end_resume_questions_flow"
    });

    const formData = new FormData();
    formData.append('candidateName', this.applicationForm.candidateName);
    formData.append('email', this.applicationForm.email);
    formData.append('designation', this.applicationForm.designation);
    formData.append('nameOfReference', this.applicationForm.nameOfReference);
    formData.append('description', this.applicationForm.description);
    if (this.selectedImageFile) {
        formData.append('candidateImage', this.selectedImageFile);
    }
    if (this.selectedResumeFile) {
        formData.append('candidateResume', this.selectedResumeFile);
    }
    formData.append('recaptchaToken', this.recaptchaToken);
    formData.append('isDirectApply', "true");
    if (this.extractedResumeSections) {
        formData.append('resume_sections', JSON.stringify(this.extractedResumeSections));
    }
    const savedData = localStorage.getItem('jobApplication_temp');
    if (savedData) {
        const data = JSON.parse(savedData);
        if (data.missingDataAnswers) {
            this.missingDataAnswers = data.missingDataAnswers;
        }
        if (data.missingDataQuestions) {
            this.missingDataQuestions = data.missingDataQuestions;
        }
    }
    
    if (this.missingDataQuestions && this.missingDataQuestions.length > 0) {
        const answersArray = this.missingDataQuestions.map((item, index) => ({
            missing_item: item.missing_item,
            question: item.question,
            answer: (() => {
                const v = (this.missingDataAnswers[index] ?? '').toString().trim();
                return v ? v : '';
            })()
        }));
        formData.append('missing_resume_data', JSON.stringify(answersArray));
    }
    
    try {
        const response = await axios.post(`${API_BASE_URL}/candidates/`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        this.resetForm();
        this.imageUploaded = false;
        this.resumeUploaded = false;
        localStorage.removeItem('jobApplication_temp');
        Swal.fire({
            icon: 'success',
            title: 'Form Submitted Successfully!',
            showConfirmButton: false,
            timer: 1500
        });
    } catch (error : any) {
                console.log(error);
                Swal.fire({
                icon: 'error',
                title: 'Submission Failed',
                text: error?.response?.data.error || 'Something went wrong. Please try again.',
                showConfirmButton: true
});
    } finally {
        // Reset submitting state
        this.isSubmitting = false;
        if (window.grecaptcha && this.recaptchaWidgetId !== null) {
            window.grecaptcha.reset(this.recaptchaWidgetId);
            }
    }
},
resetForm() {
    this.applicationForm = {
        candidateName: '',
        email: '',
        designation: '',
        nameOfReference: '',
        candidateImage: null,
        candidateResume: null,
        description: ''
    };
    this.selectedImageFile = null;
    this.selectedResumeFile = null;
    this.imageSrc = '';
    this.errMsg = '';
    this.imageUploaded = false;
    this.resumeUploaded = false;
    this.ResumeName = '';
    this.fileInputKey++;
    this.uploadProgress = 0;
    this.missingDataQuestions = [];
    this.missingDataAnswers = {};
    this.extractedResumeSections = null;
    this.activeAccordion = -1;
    this.applicationErrors = {
        candidateName: '',
        email: '',
        designation: '',
        candidateResume:''
    };
    this.isSubmitting = false;
    this.suppressLocalSave = true;
    localStorage.removeItem('jobApplication_temp');
    
    if (
        window.grecaptcha &&
        document.getElementById("aboutUsCaptchaWidget") &&
        this.recaptchaWidgetId !== null
    ) {
        console.log("Resetting reCAPTCHA widget for Join Us");
        try {
        window.grecaptcha.reset(this.recaptchaWidgetId);
        this.recaptchaWidgetId = null;
        this.recaptchaError = "";
        } catch (error) {
        console.error("Error resetting reCAPTCHA:", error);
        this.recaptchaWidgetId = null;
        }
    }
    setTimeout(() => { this.suppressLocalSave = false; }, 0);
},
        async getJobCategories() {
            try {
                const response = await axios.get(`${API_BASE_URL}/jobcategory/?status=1`);
                this.jobCategories = response.data;
            } catch (error) {
                console.error('Error fetching job categories:', error);
            }
        },
        handleFileUpload(event: any) {
            const target = event.target as HTMLInputElement;
            if (target && target.files && target.files.length > 0) {
                const file = target.files[0];
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = (e) => {
                    if (e.target && typeof e.target.result === 'string') {
                        this.imageSrc = e.target.result;
                        this.selectedImageFile = file;
                        this.imageUploaded = true

                    }
                };
            }
        },

        isValidEmail(email: string): boolean {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(email);
        },

        async handleResumeUpload(event: Event) {
            const target = event.target as HTMLInputElement;
            const file = target.files?.[0];
            if (!this.applicationForm.designation) {
                try {
                    Swal.fire({
                        icon: 'warning',
                        title: 'Select Job',
                        text: 'Please select a job before uploading your resume.',
                        showConfirmButton: false,
                        timer: 1800
                    });
                } catch {}
                if (target) target.value = '';
                return;
            }
            if (file) {
                this.selectedResumeFile = file;
                this.ResumeName = this.selectedResumeFile.name;
                this.resumeUploaded = true;
                this.uploadProgress = 0;
                const progressInterval = setInterval(() => {
                    if (this.uploadProgress < 90) {
                        this.uploadProgress += 10;
                    }
                }, 100);
                await this.extractResumeData(file);
                clearInterval(progressInterval);
                this.uploadProgress = 100;
                this.saveToLocalStorage();
            }
        },
        async extractResumeData(file: File) {
            this.isExtracting = true;
            
            try {
                const formData = new FormData();
                formData.append('resume', file);
                formData.append('designation', this.applicationForm.designation);
                
                const response = await axios.post(
                    `${API_BASE_URL}/candidates/extract-resume/`,
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                );
                if (response.data.success) {
                    this.extractedResumeSections = response.data.resume_sections;
                    if (response.data.missing_data && response.data.missing_data.length > 0) {
                        this.missingDataQuestions = response.data.missing_data;
                        this.missingDataAnswers = {};
                        this.missingDataQuestions.forEach((item, index) => {
                            this.missingDataAnswers[index] = '';
                        });
                        await this.triggerResumeQuestionsFlow();
                    }
                    this.saveToLocalStorage();
                }
            } catch (error) {
                console.error('Error extracting resume:', error);
                Swal.fire({
                    icon: 'warning',
                    title: 'Resume Extraction',
                    text: 'Could not extract resume data. You can still submit your application.',
                    showConfirmButton: false,
                    timer: 2000
                });
            } finally {
                this.isExtracting = false;
            }
        },
        toggleAccordion(index: number) {
            this.activeAccordion = this.activeAccordion === index ? -1 : index;
        },
        async saveToLocalStorage() {
            if (this.suppressLocalSave) return;
            const existingRaw = localStorage.getItem('jobApplication_temp');
            let existing: any = {};
            try { existing = existingRaw ? JSON.parse(existingRaw) : {}; } catch { existing = {}; }

            const mergedMissingAnswers: Record<number, string> = { ...this.missingDataAnswers };
            const existingAnswers = (existing && existing.missingDataAnswers) ? existing.missingDataAnswers : {};
            if (existingAnswers && typeof existingAnswers === 'object') {
                Object.keys(existingAnswers).forEach((k: any) => {
                    const idx = Number(k);
                    const val = (existingAnswers[idx] ?? '').toString().trim();
                    if (val) {
                        mergedMissingAnswers[idx] = val;
                    }
                });
            }

            const dataToSave: any = {
                applicationForm: {
                    candidateName: this.applicationForm.candidateName,
                    email: this.applicationForm.email,
                    designation: this.applicationForm.designation,
                    nameOfReference: this.applicationForm.nameOfReference,
                    description: this.applicationForm.description
                },
                extractedResumeSections: this.extractedResumeSections,
                missingDataAnswers: mergedMissingAnswers,
                missingDataQuestions: this.missingDataQuestions,
                timestamp: new Date().toISOString()
            };
            if (this.selectedImageFile) {
                try {
                    const imageBase64 = await this.fileToBase64(this.selectedImageFile);
                    dataToSave.imageFile = {
                        name: this.selectedImageFile.name,
                        type: this.selectedImageFile.type,
                        data: imageBase64
                    };
                    dataToSave.imageSrc = this.imageSrc;
                } catch (error) {
                    console.error('Error converting image to base64:', error);
                }
            }
            if (this.selectedResumeFile) {
                try {
                    const resumeBase64 = await this.fileToBase64(this.selectedResumeFile);
                    dataToSave.resumeFile = {
                        name: this.selectedResumeFile.name,
                        type: this.selectedResumeFile.type,
                        data: resumeBase64
                    };
                    dataToSave.resumeName = this.ResumeName;
                } catch (error) {
                    console.error('Error converting resume to base64:', error);
                }
            }
            
            localStorage.setItem('jobApplication_temp', JSON.stringify(dataToSave));
        },
        loadFromLocalStorage() {
            const saved = localStorage.getItem('jobApplication_temp');
            if (saved) {
                try {
                    const data = JSON.parse(saved);
                    const savedTime = new Date(data.timestamp);
                    const now = new Date();
                    const hoursDiff = (now.getTime() - savedTime.getTime()) / (1000 * 60 * 60);
                    
                    if (hoursDiff < 24) {
                        if (data.applicationForm) {
                            this.applicationForm.candidateName = data.applicationForm.candidateName || '';
                            this.applicationForm.email = data.applicationForm.email || '';
                            this.applicationForm.designation = data.applicationForm.designation || '';
                            this.applicationForm.nameOfReference = data.applicationForm.nameOfReference || '';
                            this.applicationForm.description = data.applicationForm.description || '';
                        }
                        this.extractedResumeSections = data.extractedResumeSections || null;
                        this.missingDataAnswers = data.missingDataAnswers || {};
                        if (data.missingDataQuestions) {
                            this.missingDataQuestions = data.missingDataQuestions;
                        }
                        if (data.imageFile) {
                            this.selectedImageFile = this.base64ToFile(
                                data.imageFile.data,
                                data.imageFile.name,
                                data.imageFile.type
                            );
                            this.imageSrc = data.imageSrc || '';
                            this.imageUploaded = true;
                        }
                        if (data.resumeFile) {
                            this.selectedResumeFile = this.base64ToFile(
                                data.resumeFile.data,
                                data.resumeFile.name,
                                data.resumeFile.type
                            );
                            this.ResumeName = data.resumeName || '';
                            this.resumeUploaded = true;
                            this.uploadProgress = 100;
                        }
                    } else {
                        localStorage.removeItem('jobApplication_temp');
                    }
                } catch (e) {
                    console.error('Error loading from localStorage:', e);
                }
            }
        },
        async submitContactUs(){
            // Clear previous errors
        this.contactUsErrors = {
            name: '',
            email: '',
            subject: '',
            message: ''
        };

        let hasErrors = false;

        // Validate each field
        if (!this.contactUsForm.name) {
            this.contactUsErrors.name = 'Please enter a name';
            hasErrors = true;
        }
        if (!this.contactUsForm.email) {
            this.contactUsErrors.email = 'Please enter an email';
            hasErrors = true;
        } else if (!this.isValidEmail(this.contactUsForm.email)) {
            this.contactUsErrors.email = 'Please enter a valid email address';
            hasErrors = true;
        }
        if (!this.contactUsForm.subject) {
            this.contactUsErrors.subject = 'Please enter a subject';
            hasErrors = true;
        }
        if (!this.contactUsForm.message) {
            this.contactUsErrors.message = 'Please enter a message';
            hasErrors = true;
        }

        // If there are errors, stop here
        if (hasErrors) {
            return;
        }
            const formData = new FormData();
            formData.append('name', this.contactUsForm.name);
            formData.append('email', this.contactUsForm.email);
            formData.append('subject', this.contactUsForm.subject);
            formData.append('message', this.contactUsForm.message);
            try {
                const response = await axios.post(`${API_BASE_URL}/contactus/`,formData)
                this.resetContactUsForm()
                Swal.fire({
                    icon: 'success',
                    title: 'Form Submitted Successfully!',
                    showConfirmButton: false,
                    timer: 1500
                });
            } catch (error) {
                console.error(Error)
            }
        },
        resetContactUsForm() {
            this.contactUsForm = {
                name: '',
                email: '',
                subject: '',
                message: ''
            };
            this.contactUsErrors = {
                name: '',
                email: '',
                subject: '',
                message: ''
            };
        },
        cleanupRecaptcha() {
            if (window.grecaptcha && this.recaptchaWidgetId !== null) {
                console.log("Cleaning up reCAPTCHA widget for Join Us");
                try {
                window.grecaptcha.reset(this.recaptchaWidgetId);
                this.recaptchaWidgetId = null;
                this.recaptchaToken = "";
                this.recaptchaError = "";
                } catch (error) {
                console.error("Error cleaning up reCAPTCHA:", error);
                this.recaptchaWidgetId = null;
                }
            }
        },

        onRecaptchaLoad() {
            console.log("reCAPTCHA script loaded for Join Us");
            this.renderRecaptcha();
        },

        renderRecaptcha() {
            const widgetElement = document.getElementById(
                "aboutUsCaptchaWidget"
            );
            if (window.grecaptcha && widgetElement) {
                console.log("Rendering reCAPTCHA widget for Join Us");
                try {
                window.grecaptcha.ready(() => {
                    // Only render if widgetId is null and element is empty
                    if (
                    this.recaptchaWidgetId === null &&
                    !widgetElement.hasChildNodes()
                    ) {
                    this.recaptchaWidgetId = window.grecaptcha.render(
                        "aboutUsCaptchaWidget",
                        {
                        sitekey: this.recaptchaSiteKey,
                        callback: this.onRecaptchaSuccess.bind(this),
                        "expired-callback": this.onRecaptchaExpired.bind(this),
                        }
                    );
                    this.recaptchaError = "";
                    } else {
                    console.log(
                        "reCAPTCHA widget already rendered or element not empty"
                    );
                    }
                });
                } catch (error) {
                console.error("Error rendering reCAPTCHA:", error);
                this.recaptchaError = "Failed to render reCAPTCHA. Please try again.";
                }
            } else {
                console.error("grecaptcha or captchaWidget not available");
                this.recaptchaError = "reCAPTCHA not available. Please try again.";
            }
        },

        onRecaptchaSuccess(token: string) {
            console.log("reCAPTCHA verified for Join Us, token:", token);
            this.recaptchaToken = token;
            this.recaptchaError = "";
        },

        onRecaptchaExpired() {
            console.log("reCAPTCHA expired for Join Us");
            this.recaptchaToken = "";
            this.recaptchaError = "reCAPTCHA has expired. Please try again.";
        },
        fileToBase64(file: File): Promise<string> {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result as string);
                reader.onerror = error => reject(error);
            });
        },
        base64ToFile(base64: string, filename: string, mimeType: string): File {
            const arr = base64.split(',');
            const bstr = atob(arr[1]);
            let n = bstr.length;
            const u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new File([u8arr], filename, { type: mimeType });
        },
        openChatbotPopup() {
            const chatbotElement = document.querySelector('.ai-chat-bot');
            if (chatbotElement) {
                chatbotElement.classList.add('show-chat-bot');
            }
        },
        closeChatbotPopup() {
            const chatbotElement = document.querySelector('.ai-chat-bot');
            if (chatbotElement) {
                chatbotElement.classList.remove('show-chat-bot');
            }
        },
        async triggerResumeQuestionsFlow() {
            this.openChatbotPopup();
            const missingDataPayload = this.missingDataQuestions.map((item, index) => ({
                missing_item: item.missing_item,
                question: item.question,
                answer: this.missingDataAnswers[index] || 'no'
            }));
            await axios.post(`${API_BASE_URL}/chat-message/`, {
                session_id: sessionStorage.getItem("chat_session_id"),
                message: JSON.stringify({
                    type: "resume_missing_data_init",
                    data: missingDataPayload
                })
            });
            await axios.post(`${API_BASE_URL}/chat-message/`, {
                session_id: sessionStorage.getItem("chat_session_id"),
                message: "start_resume_questions_flow"
            });

            const chatbotComponent = this.$refs?.chatbotPopup as any;
            if (chatbotComponent && typeof chatbotComponent.fetchHistory === 'function') {
                try {
                    await chatbotComponent.fetchHistory();
                } catch (e) {
                    setTimeout(() => {
                        if (typeof chatbotComponent.fetchHistory === 'function') {
                            chatbotComponent.fetchHistory();
                        }
                    }, 300);
                }
            }
        },
        async sendMissingDataToBackend() {
            try {
                const missingDataPayload = this.missingDataQuestions.map((item, index) => ({
                    missing_item: item.missing_item,
                    question: item.question,
                    answer: this.missingDataAnswers[index] || 'no'
                }));
                
                await axios.post(`${API_BASE_URL}/chat-message/`, {
                    session_id: sessionStorage.getItem("chat_session_id"),
                    message: JSON.stringify({
                        type: "resume_missing_data_init",
                        data: missingDataPayload
                    })
                });
                
                console.log('Missing data sent to backend successfully');
            } catch (error) {
                console.error('Error sending missing data to backend:', error);
            }
        }
    }
});
</script>